// @ts-nocheck
// Embedded Facebook login for ONE profile.
//
// This replaces the old `profilelogin.fbzipper.com/?id=<profileId>` iframe. The
// login surface is now /c/:code — an unguessable per-profile link that streams
// the bot's own mobile browser, so the customer signs in (2FA and checkpoints
// included) against the session that will actually do the posting.
//
// Minting is server-side and reuses the profile's live link, so mounting this in
// several places (or remounting) does not invalidate a link already sent out.
import React, {useEffect, useState} from 'react'
import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL

type Props = {
  profileId: string
  title?: string
  className?: string
  style?: React.CSSProperties
}

const ProfileLoginFrame: React.FC<Props> = ({profileId, title = 'Facebook Login', className, style}) => {
  const [url, setUrl] = useState('')
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    if (!profileId) return
    let cancelled = false
    setFailed(false)
    axios
      .post(`${API_URL}/api/profiles/${profileId}/connect-link`, {})
      .then((r) => { if (!cancelled) r.data?.url ? setUrl(r.data.url) : setFailed(true) })
      .catch((e) => { if (!cancelled) { setFailed(true); console.error('[ProfileLoginFrame] connect link failed:', e) } })
    return () => { cancelled = true }
  }, [profileId])

  if (failed) {
    return (
      <div className={className} style={{display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', minHeight: 200, color: '#f1416c', fontSize: 13, textAlign: 'center', padding: 16, ...style}}>
        לא הצלחנו להכין את מסך ההתחברות. רעננו את הדף ונסו שוב.
      </div>
    )
  }

  if (!url) {
    return (
      <div className={className} style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', minHeight: 200, gap: 10, color: '#65676b', fontSize: 13, ...style}}>
        <div className='spinner-border text-primary' role='status' />
        מכינים את מסך ההתחברות…
      </div>
    )
  }

  // The escape hatch: a corner button that opens the same link in a real tab.
  // Inside a phone mockup the frame is small and the soft keyboard has nowhere
  // to go, so anyone struggling in the embed can just take the login full-screen.
  return (
    <div className={className} style={{position: 'relative', width: '100%', height: '100%', ...style}}>
      <iframe src={url} title={title} style={{width: '100%', height: '100%', border: 0, display: 'block'}} />
      <a
        href={url}
        target='_blank'
        rel='noreferrer'
        title='פתח בכרטיסייה חדשה'
        style={{position: 'absolute', top: 6, left: 6, zIndex: 2, display: 'flex', alignItems: 'center', justifyContent: 'center', width: 28, height: 28, borderRadius: 8, background: 'rgba(13,17,23,0.72)', color: '#fff', fontSize: 14, textDecoration: 'none', backdropFilter: 'blur(2px)'}}
      >
        ↗
      </a>
    </div>
  )
}

export default ProfileLoginFrame
